// Correo del alumno (Esteban, 2026-09-28): llegaban direcciones, DNIs y "nombregmail.com" en el campo de correo.
// Igual que Util::correoInvalido del backend. Vacío = null (si es obligatorio lo dice el formulario).

const MAL_ESCRITOS: { [d: string]: string } = {
	"gmall.com": "gmail.com", "gmial.com": "gmail.com", "gamil.com": "gmail.com", "gmai.com": "gmail.com",
	"gmail.co": "gmail.com", "gmail.con": "gmail.com", "gmail.cm": "gmail.com", "gmil.com": "gmail.com", "gnail.com": "gmail.com",
	"hotmial.com": "hotmail.com", "hotmal.com": "hotmail.com", "hotmail.co": "hotmail.com", "hotmail.con": "hotmail.com", "hotmai.com": "hotmail.com",
	"yahooo.com": "yahoo.com", "yaho.com": "yahoo.com", "yahoo.con": "yahoo.com",
	"outlok.com": "outlook.com", "outlook.con": "outlook.com", "iclod.com": "icloud.com", "icloud.con": "icloud.com"
}

export function correoInvalido(correo: any): string | null
{
	const c = String(correo || "").trim().toLowerCase()
	if(c === "") return null
	if(!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/.test(c)) return "El correo no es válido: debe ser como nombre@gmail.com (sin espacios, con @ y el dominio)."
	const dominio = c.slice(c.lastIndexOf("@") + 1)
	if(MAL_ESCRITOS[dominio]) return `El correo parece mal escrito: ¿es @${MAL_ESCRITOS[dominio]} en vez de @${dominio}?`
	return null
}
